module.exports = __webpack_public_path__ + "static/img/about_introduce_02_zh_h5.a3c68cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_introduce_02_zh_h5.png
// module id = 9yjx
// module chunks = 34